<div class="modal-content">
  <div class="modal-header mb-n1">
    <span aria-hidden="true">
      <mdb-icon
        id="closeModalInfoIcon"
        tabindex="0"
        class="modal-close-icon"
        aria-label="Close"
        (click)="onClose()"
        fas
        icon="times"
      ></mdb-icon>
    </span>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h3 class="mb-4">{{ title }}</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center mb-4">
        {{ content }}
      </div>
    </div>
    @if (!decisionMode) {
      <div class="row">
        <div class="col-md-12 text-center">
          <a id="closeModalLink" class="btn primary-btn waves-light uppercase" mdbBtn mdbWavesEffect (click)="onClose()"> Close</a>
        </div>
      </div>
    }
    @if (decisionMode) {
      <div class="row">
        <div class="col-md-12 text-center">
          <button
            id="confirmModalButton"
            class="btn primary-btn waves-light uppercase"
            mdbBtn
            mdbWavesEffect
            (click)="onConfirm()"
            >
            {{ confirmButtonText }}
          </button>
          @if (secondOptionText) {
            <button
              id="secondConfirmModalButton"
              class="btn secondary-btn waves-light uppercase mr-2"
              mdbBtn
              mdbWavesEffect
              (click)="onSecondConfirm()"
              >
              {{ secondOptionText }}
            </button>
          }
          @if (!secondOptionText) {
            <button
              id="cancelModalButton"
              class="btn secondary-btn waves-light uppercase mr-2"
              mdbBtn
              mdbWavesEffect
              (click)="onCancel()"
              >
              {{ cancelButtonText }}
            </button>
          }
          @if (secondOptionText) {
            <div class="pt-2"><a id="cancelModalLink" (click)="onCancel()">Cancel</a></div>
          }
        </div>
      </div>
    }
  </div>
</div>
